import myAxios from "@/utils/request";
export default {
  getComponentList(params) {
    return myAxios.post("/api/componentdeclare/getbackpaging", params);
  },
  batchComponentDelete(params) {
    return myAxios.post("/api/componentdeclare/batchdelete", params);
  },
  addComponent(params) {
    return myAxios.post("/api/componentdeclare/backaddoredit", params);
  },
  getComponentInfo(params) {
    const { id } = params;
    return myAxios.get("/api/componentdeclare/backgetinfo?id=" + id);
  },
  getRobotList(params) {
    return myAxios.post("/api/supplydeclare/getbackpaging", params);
  },
  batchRobotelete(params) {
    return myAxios.post("/api/supplydeclare/batchdelete", params);
  },
  addRobot(params) {
    return myAxios.post("/api/supplydeclare/backaddoredit", params);
  },
  getRobotInfo(params) {
    const { id } = params;
    return myAxios.get("/api/supplydeclare/backgetinfo?id=" + id);
  }
};
